export const MAIN_CLASS_NAME = 'elma365-toolset-info-bar';
export const COLUMN_CLASS_NAME = `${MAIN_CLASS_NAME}__column`;
export const COLUMN_TITLE_CLASS_NAME = `${COLUMN_CLASS_NAME}_title`;
